import React from 'react'
import styled from 'styled-components'
import { useTranslation } from '@i18n'
import tw from 'twin.macro'
import {
  DescriptionContainer,
  LollipopImage,
  ModalContainer,
  ModalContentContainer,
  TitleContainer,
} from './MobileR18Alert'

const YesButton = styled.button`
  cursor: pointer;
  margin-top: 40px;
  ${tw`bg-primary-indigo`}
  text-align: center;
  height: 56px;
  border-radius: 28px;
  line-height: 56px;
  width: 100%;
  border: none;
  color: white;
  font-size: inherit;
`

const NoButton = styled.a`
  cursor: pointer;
  color: black;
  margin-top: 8px;
  height: 56px;
  border-radius: 28px;
  line-height: 56px;
  text-align: center;
  background-color: white;
  display: block;
  text-decoration: none;
`

interface AmpR18AlertProps {
  [key: string]: unknown
}

const AmpR18Alert: React.FC<AmpR18AlertProps> = () => {
  const { t } = useTranslation('alert')

  const title = t('R18AlertTitle')
  const description = t('R18AlertDescription')
  const noMessage = t('R18AlertNO')
  const yesMessage = t('R18AlertYES')

  const consentConfig = {
    consentInstanceId: 'r18-consent',
    consentRequired: true,
    promptUI: 'r18ConsentUI',
  }

  return (
    <>
      <amp-consent id="r18Consent" layout="nodisplay">
        <script
          type="application/json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(consentConfig),
          }}
        />
        <div id="r18ConsentUI">
          <ModalContainer>
            <ModalContentContainer>
              <LollipopImage src="/images/r18Alert/hey-lollipop.png" alt="18+ Warning" />
              <TitleContainer>{title}</TitleContainer>
              <DescriptionContainer>{description}</DescriptionContainer>
              <YesButton on="tap:r18Consent.accept" type="button">
                {yesMessage}
              </YesButton>
              <NoButton href="/">{noMessage}</NoButton>
            </ModalContentContainer>
          </ModalContainer>
        </div>
      </amp-consent>
    </>
  )
}

export default AmpR18Alert
